/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {FieldValues, useForm} from 'react-hook-form'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {KTSVG, Model} from 'helpers'
import {Select2DropdownField} from 'helpers/ui-components/form/Select2DropdownField'
import {
 fetchStackholders,
 fetchStackholderCategory,
 fetchUserCategory,
 fetchOnboardingItmesConfig,
 submitOnboardingItmes,
} from 'utils/api/auth/registerService'
import IDropdown, {
 OrganizationTypeList,
} from 'models/dropdown'
import GenericFormBuilder from 'helpers/ui-components/GenericFormBuilder'
import {
 IFileObject,
 IFormData,
 IFormField,
} from 'models/Common'
import {IItmeConfig, IItmesConfig} from 'models/GenericForm'
import {
 fetchOrganisationTypes,
 sendVerificationLink,
} from 'utils/api/auth/userManagementService'
import OrganisationFormFields from 'module/activity-management/view-organisation/OrganisationFormFields'
import {
 CreateOrganisationPayload,
 FormDataType,
} from 'models/ViewOrganisation'
import {
 createOrganisationApi,
 updateOrganisationApi,
} from 'utils/api/auth/organisationService'
import {toast} from 'react-toastify'
import OrganisationPreviewModal from 'module/auth/OrganisationPreviewModal'

type IProps = {
 accessDetails: IFormField
 userId: string
 loggedInUserId: number | undefined
 setLoader: (newState: boolean) => void
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RegisterNewUser = (props: IProps) => {
 const {t} = useTranslation()
 const isDisabled = true
 const [uploadedFileData, setUploadedFileData] =
  useState<IFileObject>({})
 const [successMsgModel, setSuccessMsgModel] =
  useState(false)
 const [stackholderList, setStackholderList] = useState<
  IDropdown[]
 >([])
 const [savedOrgData, setSavedOrgData] =
  useState<FormDataType | null>(null)

 const [showPreviewModal, setShowPreviewModal] =
  useState(false)

 const [isOrgEdit, setIsOrgEdit] = useState(false)
 const [isOrgEditing, setIsOrgEditing] = useState(false)
 const [
  stackholderCategoryList,
  setStackholderCategoryList,
 ] = useState<IDropdown[]>([])
 const [userCategoryList, setUserCategoryList] = useState<
  IDropdown[]
 >([])
 const [itemConfigList, setItemConfigList] = useState<
  IItmesConfig[]
 >([])
 const [showOrgModal, setShowOrgModal] = useState(false)
 const [selectedOrgField, setSelectedOrgField] =
  useState('')
 const createUserAccess =
  props.accessDetails?.createUser?.section
 const registerForm = {
  stakeholder: '',
  category: '',
  user_category: '',
  whatsapp_notif_enabled: '',
  country: 'ind',
 }
 const [orgFormData, setOrgFormData] =
  useState<FormDataType>({
   name: '',
   type: '',
   state: null,
   district: null,
   subDistrict: null,
   state_name: '',
   district_name: '',
   subDistrict_name: '',
   pan_number: '',
   gst_number: '',
   territory: null,
   territory_name: '',
   commercial_area: null,
   commercial_area_name: '',
   pincode: '',
   full_address: '',
  })
 const {
  register,
  unregister,
  control,
  reset,
  getValues,
  watch,
  setValue,
  handleSubmit,
  formState: {errors},
 } = useForm<FieldValues>({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...registerForm},
 })

 const getStackholderCategory = async (
  stackholderId: number
 ) => {
  props.setLoader(true)
  setValue('category', '')
  setValue('user_category', '')
  setStackholderCategoryList([])
  setUserCategoryList([])
  const res: IDropdown[] = await fetchStackholderCategory(
   stackholderId,
   'new_user_creation'
  )
  if (res) {
   setStackholderCategoryList(res)
  }
  props.setLoader(false)
 }

 const getUserCategory = async (categoryId: number) => {
  props.setLoader(true)
  setValue('user_category', '')
  setUserCategoryList([])
  const stackholderId = parseInt(getValues('stakeholder'))
  const res: IDropdown[] = await fetchUserCategory(
   stackholderId,
   categoryId
  )
  if (res) {
   setUserCategoryList(res)
  }
  props.setLoader(false)
 }

 const getOnboardingItmesConfig = async (
  userCategoryId: number,
  parentId: number
 ) => {
  const res: IItmesConfig[] =
   await fetchOnboardingItmesConfig(
    userCategoryId,
    parentId
   )
  return res
 }
 const mapOrgPayload = (
  data: FormDataType
 ): CreateOrganisationPayload => {
  return {
   name: data.name,
   type: data.type,
   category: data.type,
   state: data.state,
   district: data.district,

   sub_district: data.subDistrict,
   commercial_area: data.commercial_area,
   territory: data.territory,

   pan_number: data.pan_number,
   gstin_number: data.gst_number,

   pin_code: data.pincode,
   full_address: data.full_address,
  }
 }

 const handleCreateOrganisation = async (
  data: FormDataType
 ) => {
  try {
   const payload = mapOrgPayload(data)

   const types = (await fetchOrganisationTypes({
    distributor_needed: true,
   })) as OrganizationTypeList[]
   const value =
    payload.category?.trim().toUpperCase() || ''
   const matchedType = types.find(
    (item) =>
     item.key?.trim().toUpperCase() === value ||
     item.display_name?.trim().toUpperCase() === value
   )
   const resolvedType = matchedType?.key || ''

   if (!resolvedType) {
    toast.error('Organisation type is required')
    return
   }

   payload.type = resolvedType
   payload.category = resolvedType
   const typeDisplayName = matchedType?.display_name || ''

   const panRegex = /^[A-Z]{3}[CF][A-Z][0-9]{4}[A-Z]{1}$/

   if (!payload.pan_number) {
    toast.error('PAN Number is required')
    return
   }

   const pan = payload.pan_number.trim().toUpperCase()

   if (!panRegex.test(pan)) {
    toast.error(
     t('organisation.organisationForm.invalidPanNumber')
    )
    return
   }

   payload.pan_number = pan

   let res

   if (isOrgEdit && data.id) {
    res = await updateOrganisationApi({
     org_id: data.id,
     ...payload,
    })
   } else {
    res = await createOrganisationApi(payload)
   }

   const org = res?.data

   if (!org?.id) return

   setSavedOrgData({
    ...data,
    type: resolvedType,
    type_name: typeDisplayName,
    id: org.id,
   })

   setIsOrgEdit(false)
   setIsOrgEditing(false)

   if (selectedOrgField) {
    setValue(selectedOrgField, org.id)
   }

   setItemConfigList((prev) => {
    return prev.map((item) => ({
     ...item,
     fields: item.fields.map((field) => {
      if (field.label_key === selectedOrgField) {
       return {
        ...field,
        custom_data: [...(field.custom_data || []), org],
       }
      }
      return field
     }),
    }))
   })

   toast.success(
    isOrgEdit
     ? 'Organisation updated successfully'
     : 'Organisation created successfully'
   )

   setShowOrgModal(false)
  } catch (e) {
   toast.error('Something went wrong')
  }
 }

 const setOnboardingItmes = async (
  userCategoryId: number
 ) => {
  props.setLoader(true)
  setItemConfigList([])
  const parentRes: IItmesConfig[] | undefined =
   await getOnboardingItmesConfig(userCategoryId, 0)
  if (parentRes) {
   parentRes.map(async (val: IItmesConfig) => {
    if (val?.item_identifier === 'basic_profile') {
     const childRes: IItmesConfig[] | undefined =
      await getOnboardingItmesConfig(userCategoryId, val.id)
     if (childRes) {
      setItemConfigList(childRes)
     }
    }
   })
  }
  props.setLoader(false)
 }

 async function submitFormData(
  registerFormData: IFormData
 ) {
  props.setLoader(true)
  console.log('registerFormData', registerFormData)
  console.log(itemConfigList, 'itemConfigList')
  console.log(
   userCategoryList.filter(
    (data) => data.id === registerFormData.user_category
   )[0]
  )
  const onBoardingItems: IItmeConfig[] = []
  for (const data of itemConfigList) {
   const fields: IFormData = {}
   for (const field of data.fields) {
    let value
    const labelKey = field.label_key
    if (field.field_type === 'TOGGLE_FIELD') {
     value = registerFormData?.[labelKey]?.toString()
    } else if (field.field_type === 'IMAGE_FIELD') {
     value = uploadedFileData?.[labelKey]?.filePath
    } else if (field.field_type === 'FILE_FIELD') {
     value = uploadedFileData?.[labelKey]?.filePath
    } else {
     value = registerFormData?.[labelKey]
    }

    fields[labelKey] = value
   }

   onBoardingItems.push({
    id: data.id,
    user_category: data.user_category,
    item_identifier: data.item_identifier,
    fields,
   })
  }
  const res = await submitOnboardingItmes({
   onboarding_items: onBoardingItems,
  })
  if (res) {
   setSuccessMsgModel(true)
   const sendVerificationPayload = {
    user_data: [
     {
      full_name: registerFormData.name,
      organisation: res.organisation_name,
      user_category: res?.user_category,
      phone_number: registerFormData.phone_number,
     },
    ],
   }
   await sendVerificationLink(sendVerificationPayload)
  }
  props.setLoader(false)
 }
 const handleCloseBtnClick = () => {
  setSuccessMsgModel(false)
  window.location.reload()
 }

 const resetForm = async () => {
  setStackholderCategoryList([])
  setUserCategoryList([])
  setItemConfigList([])
  reset()
 }

 useEffect(() => {
  const getStackholders = async () => {
   props.setLoader(true)
   const res: IDropdown[] = await fetchStackholders()
   if (res) {
    setStackholderList(res)
   }
   props.setLoader(false)
  }
  void getStackholders()
 }, [])

 return (
  <>
   <Model
    show={successMsgModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 bg-[#E6EBF0] rounded-3xl w-7 h-7'
    header={''}
    close={() => {
     handleCloseBtnClick()
    }}
    modelClass='md:w-[400px]'
    modelContainerClass='!rounded-3xl px-6 py-10'
    modelBodyClass=''
   >
    <div className='w-full'>
     <div className='w-full text-center items-center'>
      <p className='text-[#33393D] font-bold text-lg border-b border-b-[#CED8E0] pb-2'>
       {t('userManagement.registerUser.successMsg')}
      </p>
      <div className='flex flex-col justify-center items-center mt-7'>
       <KTSVG
        className={''}
        path='/media/icons/user-register-success.svg'
       />
       <p className='text-[5A6066] font-semibold text-xs pt-2'>
        {t('userManagement.registerUser.successMsg2')}
       </p>
      </div>
     </div>
    </div>
   </Model>
   <div className='w-full'>
    <div className='flex items-center justify-between text-[#171B1F] text-xl font-bold border-[#E6EBF0] border-b pb-6'>
     <div>{t('userManagement.registerUser.title')}</div>
     {createUserAccess?.bulkUpload?.canEdit && (
      <div className='flex items-center '>
       <Button
        type='button'
        disabled={false}
        color='blue'
        className='text-center py-[9px] px-6 bg-[#4E83E4] 
                  !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
       >
        {t('userManagement.registerUser.bulkUpload')}
       </Button>
      </div>
     )}
    </div>

    <form
     method='POST'
     action=''
     onSubmit={handleSubmit(submitFormData)}
    >
     <div className='text-[#2F2F2F] text-2xl font-medium my-8'>
      {t('myAccountPage.officialInformation.title')}
     </div>
     <div className='grid md:grid-cols-3 gap-5 w-full mt-4 text-[#171B1F]'>
      <Select2DropdownField
       label={t('userManagement.registerUser.stakeholder')}
       labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
       className={`${
        isDisabled
         ? '!text-[#33393D] font-medium '
         : 'font-normal !text-[#33393D]'
       } boxed-select2 relative block text-lg border-0  !rounded-l-lg`}
       wrapperClassName='relative w-full'
       inputWrapperClassName='pl-4 py-2 px-4 '
       required={true}
       disabled={false}
       isClearable={false}
       isSearchable={true}
       control={control}
       customStyle={{
        transition: 'unset',
        boxShadow: 'unset',
        border: '0px',
        borderRadius: '0px',
        padding: '0px 0px 0px 0px',
        minHeight: 'auto',
       }}
       data={stackholderList}
       rules={{
        validate: {
         required: (v: string) => {
          if (v === '')
           return `${t('helperText.plsSelect')} ${t(
            'userManagement.registerUser.stakeholder'
           )}`
         },
        },
        onChange: (e: {target: {value: number}}) => {
         void getStackholderCategory(e.target.value)
        },
       }}
       id={`stakeholder`}
       name={`stakeholder`}
       OptionValueKey='id'
       OptionLabelKey='name'
       placeholder={`${t('helperText.select')} ${t(
        'userManagement.registerUser.stakeholder'
       )}`}
       errors={errors}
      />
      <Select2DropdownField
       label={t('userManagement.registerUser.category')}
       labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
       className={`${
        isDisabled
         ? '!text-[#33393D] font-medium '
         : 'font-normal !text-[#33393D]'
       } boxed-select2 relative block text-lg border-0  !rounded-l-lg`}
       wrapperClassName='relative w-full'
       inputWrapperClassName='pl-4 py-2 px-4 '
       required={true}
       disabled={false}
       isClearable={false}
       isSearchable={true}
       control={control}
       customStyle={{
        transition: 'unset',
        boxShadow: 'unset',
        border: '0px',
        borderRadius: '0px',
        padding: '0px 0px 0px 0px',
        minHeight: 'auto',
       }}
       data={stackholderCategoryList}
       rules={{
        validate: {
         required: (v: string) => {
          if (v === '')
           return `${t('helperText.plsSelect')} ${t(
            'userManagement.registerUser.category'
           )}`
         },
        },
        onChange: (e: {target: {value: number}}) => {
         void getUserCategory(e.target.value)
        },
       }}
       id={`category`}
       name={`category`}
       OptionValueKey='id'
       OptionLabelKey='name'
       placeholder={`${t('helperText.select')} ${t(
        'userManagement.registerUser.category'
       )}`}
       errors={errors}
      />
      <Select2DropdownField
       label={t('userManagement.registerUser.userCategory')}
       labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
       className={`${
        isDisabled
         ? '!text-[#33393D] font-medium '
         : 'font-normal !text-[#33393D]'
       } boxed-select2 relative block text-lg border-0  !rounded-l-lg`}
       wrapperClassName='relative w-full'
       inputWrapperClassName='pl-4 py-2 px-4 '
       required={true}
       disabled={false}
       isClearable={false}
       isSearchable={true}
       control={control}
       customStyle={{
        transition: 'unset',
        boxShadow: 'unset',
        border: '0px',
        borderRadius: '0px',
        padding: '0px 0px 0px 0px',
        minHeight: 'auto',
       }}
       data={userCategoryList}
       rules={{
        validate: {
         required: (v: string) => {
          if (v === '')
           return `${t('helperText.plsSelect')} ${t(
            'userManagement.registerUser.userCategory'
           )}`
         },
        },
        onChange: (e: {target: {value: number}}) => {
         void setOnboardingItmes(e.target.value)
        },
       }}
       id={`user_category`}
       name={`user_category`}
       OptionValueKey='id'
       OptionLabelKey='name'
       placeholder={`${t('helperText.select')} ${t(
        'userManagement.registerUser.userCategory'
       )}`}
       errors={errors}
      />
      {itemConfigList.length > 0 && (
       <GenericFormBuilder
        itemConfigList={itemConfigList}
        excludedFields={[
         'stakeholder',
         'category',
         'user_category',
        ]}
        parentId={''}
        itemIdentifier={'official_information'}
        uploadedFileData={uploadedFileData}
        setUploadedFileData={setUploadedFileData}
        setLoader={props.setLoader}
        register={register}
        unregister={unregister}
        control={control}
        getValues={getValues}
        errors={errors}
        watch={watch}
        setValue={setValue}
        onOrganisationSelect={async (
         fieldId: React.SetStateAction<string>,
         _value: IDropdown,
         option: {id: number}
        ) => {
         if (option?.id === -1) {
          const selectedCategory =
           stackholderCategoryList.find(
            (item) =>
             item.id === Number(getValues('category'))
           )
          const selectedState = getValues('state')

          setSelectedOrgField(fieldId)

          const types = (await fetchOrganisationTypes({
           distributor_needed: true,
          })) as OrganizationTypeList[]
          const name =
           selectedCategory?.name?.trim().toUpperCase() ||
           ''
          const matchedType = types.find(
           (item) =>
            item.key?.trim().toUpperCase() === name ||
            item.display_name?.trim().toUpperCase() === name
          )

          setOrgFormData((prev) => ({
           ...prev,
           type: matchedType?.key || '',
           type_name: matchedType?.display_name || '',
           state: selectedState || null,
          }))
          setShowOrgModal(true)
         }
        }}
       />
      )}
     </div>
     {savedOrgData && (
      <div
       className='flex items-center gap-2 mt-3 cursor-pointer w-fit'
       onClick={() => setShowPreviewModal(true)}
      >
       <i
        className='fa fa-info-circle text-[#4E83E4] text-base shrink-0'
        aria-hidden='true'
       />
       <span className='text-[#33393D] text-sm'>
        {t('userManagement.registerUser.orgReviewNotice')}
       </span>
      </div>
     )}
     {itemConfigList.length > 0 && (
      <div className='w-full mt-10'>
       <div className='text-[#2F2F2F] text-2xl font-medium'>
        {t('myAccountPage.personalInformation.title')}
       </div>
       <div className='grid md:grid-cols-3 gap-5 w-full mt-4'>
        <GenericFormBuilder
         itemConfigList={itemConfigList}
         parentId={''}
         itemIdentifier={'personal_information'}
         excludedFields={['whatsapp_notif_enabled']}
         uploadedFileData={uploadedFileData}
         setUploadedFileData={setUploadedFileData}
         setLoader={props.setLoader}
         register={register}
         unregister={unregister}
         control={control}
         getValues={getValues}
         errors={errors}
         watch={watch}
         setValue={setValue}
        />
       </div>
      </div>
     )}
     {itemConfigList.length > 0 && (
      <div className='w-full mt-5'>
       <GenericFormBuilder
        itemConfigList={itemConfigList}
        parentId={''}
        itemIdentifier={'personal_information'}
        excludedFields={['']}
        includedFields={['whatsapp_notif_enabled']}
        uploadedFileData={uploadedFileData}
        setUploadedFileData={setUploadedFileData}
        setLoader={props.setLoader}
        register={register}
        unregister={unregister}
        control={control}
        getValues={getValues}
        errors={errors}
        watch={watch}
        setValue={setValue}
       />
      </div>
     )}
     <div className='w-full mt-10'>
      <div className='flex items-center justify-end'>
       {itemConfigList.length > 0 && (
        <>
         <Button
          type='button'
          disabled={false}
          onClick={resetForm}
          color='white'
          className='text-center py-[9px] px-6 bg-white 
                                      !rounded-lg text-base text-[#4E83E4] hover:bg-[#4E83E4] font-semibold border-[#4E83E4] mr-2'
         >
          {t('common.discard')}
         </Button>
         <Button
          type='submit'
          disabled={false}
          color='blue'
          className='text-center py-[9px] px-6 bg-[#4E83E4] 
                        !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
         >
          {t('registerPage.registerBtn')}
         </Button>
        </>
       )}
      </div>
     </div>
    </form>
    <Model
     show={showOrgModal}
     showHeader={false}
     header=''
     close={() => setShowOrgModal(false)}
     modelClass='md:w-[1400px]'
     modelContainerClass='!rounded-2xl'
     modelBodyClass='p-6'
    >
     <div>
      <div className='text-lg font-semibold text-gray-800 mb-3'>
       {t('organisation.title')}
      </div>

      <OrganisationFormFields
       formData={orgFormData}
       setFormData={setOrgFormData}
       isEdit={isOrgEdit}
       isEditing={isOrgEditing}
      />

      <div className='flex justify-end gap-3 mt-6'>
       <Button
        type='button'
        color='white'
        onClick={() => setShowOrgModal(false)}
        className='px-5 py-2 border border-[#4E83E4] text-[#4E83E4]'
       >
        Cancel
       </Button>

       <Button
        type='button'
        color='blue'
        onClick={async () => {
         await handleCreateOrganisation(orgFormData)
        }}
        className='px-5 py-2 bg-[#4E83E4] text-white'
       >
        Save
       </Button>
      </div>
     </div>
    </Model>
   </div>
   <OrganisationPreviewModal
    show={showPreviewModal}
    onClose={() => setShowPreviewModal(false)}
    data={savedOrgData}
    onEdit={() => {
     if (!savedOrgData) return

     setOrgFormData(savedOrgData)

     setIsOrgEdit(true)
     setIsOrgEditing(true)

     setShowPreviewModal(false)
     setShowOrgModal(true)
    }}
   />
  </>
 )
}

export default RegisterNewUser
